import { ROOT_URL, isGGI, isOLG } from './root_url';
import { getAutoCustomerNumber } from './customers_actions';

// export const TRUCKXI_LOGIN_URL = ROOT_URL + 'api-token-auth/';
// export const TRUCKXI_LOGIN_URL = 'https://afg-oauth.truckxi.com/o/token/';
// export const TRUCKXI_LOGIN_URL = 'https://ctp-scm.truckxi.com/o/token/';
// export const TRUCKXI_LOGIN_URL = 'https://lap-scm.truckxi.com/o/token/';
// export const TRUCKXI_LOGIN_URL = 'https://squarecab-scm.truckxi.com/o/token/';
// export const TRUCKXI_LOGIN_URL = 'https://hkgf-scm.truckxi.com/o/token/';
export const TRUCKXI_LOGIN_URL = 'https://kimi-scm.truckxi.com/o/token/';
// export const TRUCKXI_LOGIN_URL = 'https://oauth.truckxi.com/o/token/';
// export const TRUCKXI_LOGIN_URL = 'https://stageauth.truckxi.com/o/token/';
// export const TRUCKXI_LOGIN_URL = 'https://stageauth3.truckxi.com/o/token/';
export const TRUCKXI_TEST_URL = `${ROOT_URL}verify/test/`;
export const PERMISSION_URL = `${ROOT_URL}v1/baseuser/userpermissions/`;

export const ROOT_URL_V2 = `${ROOT_URL}v2/`;
export const SALES_ORDER_FORM_BACHES = `${ROOT_URL}v2/inventory/`;
export const PRODUCTS_URL = `${ROOT_URL}v1/product/`;
export const PRODUCTS_IMPORT_URL = `${ROOT_URL}v1/product/import-vakker-product4/`;
export const PRODUCTS_SIMPLIFIED_URL = `${ROOT_URL}v1/product/simplified/`;
export const GROUPS_URL = `${ROOT_URL}v1/product/group/`;
export const DEP_URL = `${ROOT_URL}v1/product/department/`;
export const CATEGORIES_URL = `${ROOT_URL}v1/product/category/`;
export const CATEGORIES_2_URL = `${ROOT_URL}v1/product/category2/`;
export const CATEGORIES_2_B2B_URL = `${ROOT_URL}v1/product/category2_b2b/`;
export const PRICELEVELS_URL = `${ROOT_URL}v1/product/pricelevel/`;
export const TYPES_URL = `${ROOT_URL}v1/product/type/`;
export const CUSTOMERS_URL = `${ROOT_URL}v1/customer/`;
export const CUSTOMERS_PAGINATE_URL = `${ROOT_URL}v1/customer/paginator`;
export const CUSTOMERS_STATUS_URL = `${ROOT_URL}v1/dashboard/outstanding/customer/`;
export const AGENT_URL = `${ROOT_URL}v1/agent/`;
export const PAYMENT_URL = `${ROOT_URL}v1/payment/`;
export const VENDOR_URL = `${ROOT_URL}v1/vendor/`;
export const OUTSTANDING_VENDOR_URL = `${ROOT_URL}v1/dashboard/outstanding/vendor/`;
export const VENDOR_INVENTORY_URL = `${ROOT_URL}v1/inventory/vendor/`;
export const DISPLAY_CATEGORIES_URL = `${ROOT_URL}v1/product/product_display_category/`;
export const FETCH_FJ_AGENTS_URL = `${ROOT_URL}v1/customer/agents/`;
export const FETCH_FBA_ADDRESS_URL = `${ROOT_URL}v1/sale/order-address`;
export const FETCH_FJ_CARRIERS_URL = `${ROOT_URL}v2/sales/order-carriers`;

export const FETCH_PRICE_TABLE_URL = `${ROOT_URL}v1/customer/prices/`;

export const OUTGOING_ORDERS_BY_DATE_URL = `${ROOT_URL}v1/dashboard/warehouse/sales/`;
export const INCOMING_ORDERS_BY_DATE_URL = `${ROOT_URL}v1/dashboard/warehouse/purchase/`;
export const PURCHASE_QUOTES_URL = `${ROOT_URL}v1/purchase/quote/`;
export const PURCHASE_TEMPLATES_URL = `${ROOT_URL}v1/purchase/template/`;
export const PURCHASE_SCHEDULES_URL = `${ROOT_URL}v1/purchase/schedule/`;
export const PURCHASE_RETURNS_URL = `${ROOT_URL}v1/purchase/return/`;
export const PURCHASE_RETURNS_NO_SUBTOTALS = `${ROOT_URL}v1/purchase/return_no_price/print/`;
export const PURCHASE_ORDERS_URL = `${ROOT_URL}v1/purchase/order/`;
export const PURCHASE_ORDER_COMPLETE_URL = `${ROOT_URL}v1/purchase/completed/`;
export const PURCHASE_URL = `${ROOT_URL}v1/purchase/`;
export const PURCHASE_URL_2 = `${ROOT_URL}v1/product/byid/2/`;
export const INCIDENT_REPORT_URL = `${ROOT_URL}v1/dashboard/incidents/`;
export const PRESIDENT_DASH_INFO_URL = `${ROOT_URL}v1/dashboard/president/`;
export const NUM_PURCHASE_QUOTES_URL = `${ROOT_URL}v1/dashboard/quotenum/`;
export const PURCHASE_ORDERS_NOT_RECEIVED_URL = `${ROOT_URL}v1/dashboard/notreceivednum/`;
export const TOTAL_PURCHASES_URL = `${ROOT_URL}v1/dashboard/totalnum/`;
export const DASHBOARD_URL = `${ROOT_URL}v1/dashboard/`;
export const DASHBOARD_PO_PAST_URL = `${ROOT_URL}v1/dashboard/warehouse/purchase/past_due/`;
export const DASHBOARD_SO_PAST_URL = `${ROOT_URL}v1/dashboard/warehouse/sales/past_due/`;

export const PO_SET_TO_FACTORY_URL = `${ROOT_URL}v2/purchase/set_po_status_to_factory/`;
export const PO_SET_TO_PORT_URL = `${ROOT_URL}v2/purchase/set_po_status_to_port/`;
export const PO_SET_TO_TRUCK_URL = `${ROOT_URL}v2/purchase/set_po_status_to_truck/`;
export const PO_SET_QUOTE_TO_PLACED_URL = `${ROOT_URL}v2/purchase/set-order-placed`;

export const PURCHASE_ORDER_PERFORMANCE_URL = `${ROOT_URL}v1/dashboard/orders/month/`;
export const PURCHASE_MANAGER_INFO_URL = `${ROOT_URL}v1/dashboard/purchasemanager/`;
export const LAST_MONTH_PERFORMANCE_URL = `${ROOT_URL}v1/dashboard/orders/month/`;
export const PURCHASE_TOTALS_URL = `${ROOT_URL}v1/dashboard/totalpurchases/`;
export const OVERALL_PURCHASE_PERFORMANCE_URL = `${ROOT_URL}v1/dashboard/totalpurchases/`;
export const OVERALL_SALES_PERFORMANCE_URL = `${ROOT_URL}v1/dashboard/totalsales/`;
export const SALES_LEVELS_URL = `${ROOT_URL}v1/dashboard/salesdashboard/`;
export const CONSOLODATED_STATISTICS_URL = `${ROOT_URL}v1/dashboard/consolidated_statistics/`;
export const INVENTORIES_URL = `${ROOT_URL}v1/inventory/simplified/`;
export const DETAILED_INVENTORIES_URL = `${ROOT_URL}v1/inventory/detailed/`;
export const SALES_ORDER_INVENTORY_URL = `${ROOT_URL}v1/inventory/sales_order/`;
export const SALES_ORDER_EXISTING_URL = `${ROOT_URL}v1/sale/sales_order/existing`;
export const FREQUENT_ITEMS_URL = `${ROOT_URL}v1/sale/frequent/`;
export const INBOUND_PRODUCTS_URL = `${ROOT_URL}v2/sales/inbound-order-products`;
export const INVENTORY_URL = `${ROOT_URL}v1/inventory/`;
export const INVENTORY_HISTORY_URL = `${ROOT_URL}v1/inventory/history/`;

export const INVENTORY_RELOCATIONS_URL = `${ROOT_URL}v1/warehouse/relocation/`;
export const INVENTORY_REPACKAGES_URL = `${ROOT_URL}v1/warehouse/repackage/`;
export const INVENTORY_ADJUSTMENTS_URL = `${ROOT_URL}v1/warehouse/adjustment/`;
export const QUICK_INVENTORY_ADJUSTMENTS_URL = `${ROOT_URL}v1/warehouse/quick/adjustment/`;
export const INVENTORY_CONVERTS_URL = `${ROOT_URL}v1/warehouse/convert/`;
export const SCRAP_RECORDS_URL = `${ROOT_URL}v1/warehouse/scrap/`;
export const INVENTORY_SCRAP_URL = `${ROOT_URL}v1/inventory/bin/`;
export const WAREHOUSES_URL = `${ROOT_URL}v1/warehouse/`;
export const ZONES_URL = `${ROOT_URL}v1/warehouse/zone/`;
export const BINS_URL = `${ROOT_URL}v1/warehouse/bin/`;
export const RECEIVE_URL = `${ROOT_URL}v1/warehouse/receive/`;
export const PUT_AWAY_URL = `${ROOT_URL}v1/warehouse/receive/putaway/`;
export const ITEM_HISTORY_URL = `${ROOT_URL}v1/sale/sales_order/history/`;
export const ITEM_PURCHASE_HISTORY_URL = `${ROOT_URL}v1/purchase/purchase/history/`;

export const FAVORITES_URL = `${ROOT_URL}v1/product/inventoryproduct/`;
export const CUSTOMER_GROUPS_URL = `${ROOT_URL}v1/customer/group/`;
export const PREVIOUSORDERS_URL = `${ROOT_URL}v1/sale/sales_order/previous/`;
export const PROMOTIONS_URL = `${ROOT_URL}v1/sale/promotion/`;
export const PROMO_NOTES_URL = `${ROOT_URL}v1/sale/notes/`;
export const SALES_PERFORMANCE_URL = `${ROOT_URL}v1/sale/performance/`;
export const USER_PERFORMANCE_URL = `${ROOT_URL}v1/sale/userperformance/`;

export const PICKER_URL = `${ROOT_URL}v1/sale/picker/`;
export const SALES_ORDERS_URL = `${ROOT_URL}v1/sale/sales_order/`;
export const SEND_EMAIL = `${ROOT_URL}v1/sale/emailinvoice_by_order_id/`;
export const SALES_SAVE_TO_INVOICE = `${ROOT_URL}v1/sale/sales_order/invoice/`;
export const SALES_QUOTE_URL = `${ROOT_URL}v1/sale/sales_quote/`;
export const SALES_ORDERS_REFUND = `${ROOT_URL}v1/sale/sales_order/`;
export const MOBILE_SALES_ORDERS_URL = `${ROOT_URL}v1/sale/sales_mobile_order/`;
export const MOBILE_SALES_ORDERS_URL_v2 = `${ROOT_URL}v1/sale/sales_mobile_order_v2/`;
export const SALES_DASHBOARD_URL = `${ROOT_URL}v1/dispatch/stop/`;
export const POS_ORDERS_URL = `${ROOT_URL}v1/pos/orders/`;
export const POS_SALE_URL = `${ROOT_URL}v1/pos/order/`;
export const POS_CREDITS_URL = `${ROOT_URL}v1/pos/orders/credits`;
export const POS_CREDIT_URL = `${ROOT_URL}v1/pos/orders_credit/`;
export const POS_HOLDS_URL = `${ROOT_URL}v1/pos/hold_orders/`;
export const POS_HOLDS_VOID = `${ROOT_URL}v1/pos/void_hold_orders/`;
export const CUSTOMER_SALES_HISTORY = `${ROOT_URL}v1/sale/sales_order/customer-sales-history?customerId=`;
export const CREATE_PR_URL = `${ROOT_URL}v1/mfg/sales_order_create_mfg_and_pr/`;
export const CUSTOMERS_WITH_FAVORITES_URL = `${ROOT_URL}v1/sale/favorite/`;
export const CUSTOMER_CREDIT_LINES_URL = `${ROOT_URL}v1/dashboard/customercredit/`;
export const RELEASE_SALES_ORDER_URL = `${ROOT_URL}v1/sale/sales_invoice/`;
export const FETCH_INVOICE_DETAIL_URL = `${ROOT_URL}v1/sale/sales_invoice/search/?pk=`;
export const FETCH_SALES_INVOICES_BY_TYPE_URL = `${ROOT_URL}v1/sale/sales_invoice/search/?SaleStatus=`;
export const SALES_INVOICE_URL = `${ROOT_URL}v1/sale/sales_invoice/search/`;
export const SALES_INVOICE_NUM_URL = `${ROOT_URL}v1/sale/sales_invoice/returnable/`;
export const UNPAID_SALES_INVOICE_URL = `${ROOT_URL}v1/sale/unpaid_invoices/`;
export const SALES_ORDER_DROPDHIP_URL = `${ROOT_URL}v2/sales/generate-purchase/`;
export const MOBILE_SALES_ORDER_SHIPPINGINFO_URL = `${ROOT_URL}v1/customer/customer_address/`;
export const UPLOAD_FAVORITE_URL = `${ROOT_URL}v1/sale/favorite/import/`;
export const CREATE_PICKING_LIST_URL = `${ROOT_URL}v1/sale/pickinglist/`;
export const DUPLICATE_CUSTOMER_URL = `${ROOT_URL}v1/customer/duplicate_customers/`;

export const CUSTOMER_INVITE_URL = `${ROOT_URL}v1/customer/send_invitation`

// export const SALES_INVOICE_COMPLETED_URL = `${ROOT_URL}v1/sale/sales_invoice_completed/`;
export const SALES_INVOICE_COMPLETED_URL = `${ROOT_URL}v1/sale/sales_invoice/returnable/`;
export const SALES_INVOICE_PAYMENT_URL = `${ROOT_URL}v1/sale/sales_invoice/`;
export const EDIT_SI_CUSTOMER_URL = `${ROOT_URL}v1/sale/sales_invoice/editcustomer/`;

export const SALES_INVOICE_UPDATE_URL = `${ROOT_URL}v1/sale/sales_invoice/`;
export const SALES_INVOICE_VOID_URL = `${ROOT_URL}v1/sale/sales_invoice/void/`;
export const SALES_INVENTORY_INFO_URL = `${ROOT_URL}v1/inventory/sales_order/search/`;
export const SALES_CUSTOMER_URL = `${ROOT_URL}v1/sale/customer/`;
export const SALES_QUOTE_CUSTOMER_URL = `${ROOT_URL}v1/sale/customer/quote/`
export const SHIPPING_URL = `${ROOT_URL}v1/customer/addresses/Shipping/`;
export const AUTO_CUSTOMER_NUMBER_URL = `${ROOT_URL}v1/customer/auto_customer_number`;
export const PURCHASES_VENDOR_URL = `${ROOT_URL}v1/ap/report/aged/`;
export const SALES_ISSUE_CREDIT_URL = `${ROOT_URL}v1/sale/issue_credit/`;
export const CUSTOMER_FAVORITE_LIST = `${ROOT_URL}v1/sale/favorite/line/`;
export const WHOLESALE_URL = `${ROOT_URL}v1/sale/sales_order/wholesale/`;
export const WHOLESALE_BATCH_URL = `${ROOT_URL}v1/inventory/batch/`;
export const INVENTORY_BATCH_URL = `${ROOT_URL}v2/inventory/batch`;
export const ADJUSTMENT_INVENTORY_BATCH_URL = `${ROOT_URL}v2/inventory/adjustment`;
export const WHOLESALE_BATCH_LOG_URL = `${ROOT_URL}v2/inventory/batch-log`;
export const INVENTORY_SALES_ORDER_HISTORY_URL = `${ROOT_URL}v1/inventory/sales-order-history/`;
export const FINALIZED_INVOICES_URL = `${ROOT_URL}v1/sale/sales_invoice/finalized/`;
export const FINALIZE_INVOICE_URL = `${ROOT_URL}v1/sale/sales_invoice/finalize/`;
export const DELIVER_INVOICE_URL = `${ROOT_URL}v1/sale/sales_invoice/deliver/`;
export const SALES_ORDER_LINE_WEIGHTS_URL = `${ROOT_URL}v1/dispatch/weights/`;
export const DISPATCH_URL = `${ROOT_URL}v1/dispatch/`;
export const COMPANY_URL = `${ROOT_URL}v1/company/`;
export const WAREHOUSE_BY_COMPANY_URL = `${ROOT_URL}v1/warehouse/get_warehouse_by_company/`;

export const FETCH_SHIP_METHOD_OPTIONS_URL = `${ROOT_URL}v1/sale/shipping/list_shipping_method`;
export const SHIP_METHOD_CHANGE_URL = `${ROOT_URL}v1/sale/shipping/update_shipping_method/`;
export const SHIP_QTY_CHANGE_URL = `${ROOT_URL}v1/sale/update_order_line_quantity/`;
export const TRACKING_CHANGE_URL = `${ROOT_URL}v1/sale/edit_tracking_num/`;

export const DISPATCH_DELIVERY_FEE_URL = `${ROOT_URL}v1/company/`;
export const REQUEST_SALES_INVOICE_FORM_URL = `${ROOT_URL}v1/sale/printinvoice/`;
export const SALES_RETURN_URL = `${ROOT_URL}v1/sale/sales_return/`;
export const SALES_LOADSPOST_URL = `${ROOT_URL}v1/sale/loadspost/`;
export const TAX_RATES_URL = `${ROOT_URL}v1/purchase/taxarea/`;
export const CURRENCY_RATES_URL = `${ROOT_URL}v1/currency/`;
export const AR_URL = `${ROOT_URL}v1/ar/`;
export const AP_URL = `${ROOT_URL}v1/ap/`;
export const UPLOAD_URL = `${ROOT_URL}v1/upload/`;
export const POS_REPORT_URL = `${ROOT_URL}v1/pos/search/`;
export const PRODUCT_RECEIVE_HISTORY = `${ROOT_URL}v1/inventory/get-receiving-history/`;

export const BASE_USER_URL = `${ROOT_URL}v1/baseuser/`;
export const RESET_PASSWORD_URL = `${ROOT_URL}v1/baseuser/reset-password/`;
export const RESET_EMAIL_URL = `${ROOT_URL}v1/baseuser/mobile-change-email/`;
export const FETCH_SALES_ORDER_FORM_URL = `${ROOT_URL}v1/sale/printtest/`;
export const MESSAGE_DASHBOARD_URL = `${ROOT_URL}v1/dashboard/messages/`;
export const DELETE_USER_URL = `${ROOT_URL}v1/baseuser/users/`;
export const CHANGE_STRIPE_URL = `${ROOT_URL}v1/baseuser/change-stripe/`;
export const PACKER_URL = (isOLG || isGGI)?`${ROOT_URL}v1/sale/pickers/`:`${ROOT_URL}v1/sale/packers/`;

export const SESSION_URL = `${ROOT_URL}v1/pos/session/`;
export const REGISTER_URL = `${ROOT_URL}v1/pos/register/`;
export const VERIFY_URL = `${ROOT_URL}v1/pos/session/`;

export const SHIPPING_LIST_URL = `${ROOT_URL}v1/sale/printshippinglist/`;
export const PICKING_LIST_URL = `${ROOT_URL}v1/sale/printpickinglist/`;
export const PACKING_LIST_URL = `${ROOT_URL}v1/sale/printpackinglist/`;
export const REFUND_SUMMARY_URL = `${ROOT_URL}v1/sale/printrefund/`;
export const SALES_ORDER_PRINT_URL = `${ROOT_URL}v1/sale/printorder/`;
export const SALES_ORDER_LABEL_PRINT_URL = `${ROOT_URL}v1/sale/printshippinglabel/`;
export const WIZ_PRINT_BOL = `${ROOT_URL}v2/sales/bol/export/`;
export const SALES_ORDER_LABEL_PRINT_URL_BATCH = `${ROOT_URL}v1/sale/shipping/batch_ship/`;
export const SALES_ORDER_RESHIP_URL = `${ROOT_URL}v1/sale/sales_order/reship/`;
export const SALES_ORDER_PRODUCT_BY_ID_URL = `${ROOT_URL}v1/product/byid/`;
export const PURCHASE_ORDER_PRODUCT_BY_ID_URL = `${ROOT_URL}v1/product/`;

export const SALES_ORDER_PREPAY_STATUS_URL = `${ROOT_URL}v1/sale/set_order_to_ship/`;
export const SALES_ORDER_SUGGESTION_URL = `${ROOT_URL}v1/inventory/sales_order/search/simplified/`;
export const PURCHASE_ORDER_SUGGESTION_URL = `${ROOT_URL}v1/product/simplified/`;
export const PATCH_SALES_ORDER_WEIGHT_URL = `${ROOT_URL}v1/sale/sales_mobile_order/update_weight/`;
export const PATCH_SALES_ORDER_WEIGHT_MULTI_URL = `${ROOT_URL}v1/sale/sales_mobile_order/update_weight_multi/`;
export const PATCH_SALES_ORDER_WEIGHT_MULTI_VAK_URL = `${ROOT_URL}v1/sale/sales_mobile_order/weight_and_dimensions_update/`
export const FETCH_SALES_ORDER_WEIGHT_TRACKING = `${ROOT_URL}v1/sale/sales_mobile_order/get_weight_multi/`;
export const PATCH_SALES_EMPLOYEE_NOTE_URL = `${ROOT_URL}v1/sale/sales_mobile_order/update_sales_order_note/`;
export const PATCH_SALES_VOID_NOTE_URL = `${ROOT_URL}v1/sale/sales_mobile_order/update_sales_order_void/`;
export const PATCH_INVOICE_EMPLOYEE_NOTE_URL = `${ROOT_URL}v1/sale/sales_invoice/update_sales_invoice_note/`;


export const PURCHASE_ORDER_PRINT_URL = `${ROOT_URL}v1/purchase/order/`;
export const PURCHASE_LONGCODE_PRINT_URL = `${ROOT_URL}v2/inventory/batch/label`;
export const SO_PRINT_SALES_INVOICE_URL = `${ROOT_URL}v1/sale/printinvoice_by_so/`;
export const SALES_INVOICE_PRINT_URL = `${ROOT_URL}v1/sale/printinvoice/`;
export const SALES_INVOICE_RETURN_PRINT_URL = `${ROOT_URL}v1/sale/printreturn/`;
export const SALES_INVOICE_RETURN_PRINT_NOSUBTOTAL_URL = `${ROOT_URL}v1/sale/printreturn_no_price/`;
export const WAREHOUSE_RECEIVE_PRINT_URL = `${ROOT_URL}v1/warehouse/receive/print/`;
export const AR_PRINT_URL = `${ROOT_URL}v1/ar/report/aged/`;
export const AR_PRINT_PLAIN_URL = `${ROOT_URL}v1/ar/report/plain/`;
export const AR_REPORT_CUSTOMERS_URL = `${ROOT_URL}v1/ar/report/customers/`;
export const AP_PRINT_URL = `${AP_URL}report/aged/`;
export const BD_RMA_URL = `${ROOT_URL}v1/bd_rma/`;
export const PURCHASE_ORDER_PRINT_NOSUBTOTAL_URL = `${ROOT_URL}v1/purchase/order/print/no_price/`;
export const SALES_INVOICE_PRINT_NOSUBTOTAL_URL = `${ROOT_URL}v1/sale/printinvoice_no_price/`;
export const AR_AGED_PRINT_URL = `${ROOT_URL}v1/ar/statement/print/`;

export const ADJUSTMENT_INVENTORY_URL = `${ROOT_URL}v1/adjustment-inventory/reason`;
export const QUOTE_TO_ORDER_URL = `${ROOT_URL}v1/sale/sales_order/`;
export const ACTION_LOG_FILTER_URL = `${ROOT_URL}v1/dashboard/audit_trail_filter/`

export const MMDRIVERS = `${ROOT_URL}v1/baseuser/mmdriver-application/`;
export const verifyPasscode = `${ROOT_URL}v1/baseuser/checkpasscode/`;

//Dispatch url
export const ROUTES_PRINTER_TIME = `${ROOT_URL}v1/dispatch/route-printing-time`;

//Username url
export const USERNAME_URL = `${ROOT_URL}v1/baseuser/mobile/`

//Business Users Ecity
export const BUSINESS_USERS_URL = `${ROOT_URL}v1/baseuser/business-info/`;
export const BUSINESS_USER_CONVERT = `${ROOT_URL}v1/baseuser/business-convert/`;

//tracking note
export const TRACKING_NOTE_URL = `${ROOT_URL}v1/purchase/note/`;

// Sales Order
export const PAYMENT_METHOD_CHANGE_URL = `${ROOT_URL}v1/sale/change_mobile_so_payment_method/`;
export const MOBILE_ACCOUNT_URL = `${ROOT_URL}v1/product/system/`;
export const MOBILE_ACCOUNT_TREE_URL = `${ROOT_URL}v1/product/group_system`;

// ESL
export const ESL_INITIALIZE = `${ROOT_URL}v1/esl/product-esl-status/`;
export const ESL_DELETE = `${ROOT_URL}v1/esl/`;
export const ESL_GET_TEMPLATE = `${ROOT_URL}v1/esl/templates`;
export const ESL_SAVE = `${ROOT_URL}v1/esl/`;

// Chowbus
export const CHOWBUS_IMPORT = `${ROOT_URL}v2/import_orders_xls`;

// US Pride
export const USPRIDE_IMPORT = `${ROOT_URL}v2/import_sales_order/`;
export const USPRIDE_PRINT_SO_USPRIDE = `${ROOT_URL}v1/sale/shipping/batch_ship/`;
export const USPRIDE_REPRINT_SO_USPRIDE = `${ROOT_URL}v1/sale/shipping/reprint/`;
export const ABCFF_IMPORT = `${ROOT_URL}v2/import_sales_order/`;

// Oversea
export const OVERSEA_URL = `${ROOT_URL}v1/oversea-warehouse/`;
export const OVERSEA_UPLOAD_BOL_IMAGE_URL = `${ROOT_URL}v1/oversea-warehouse/upload-amazon-bol/`;
export const OVERSEA_DELETE_BOL_IMAGE_URL = `${ROOT_URL}v1/oversea-warehouse/delete-image/`;
export const OVERSEA_PRINT_BOL_URL = `${ROOT_URL}v1/oversea-warehouse/printing-so-bol-file/`;
export const OVERSEA_ADDRESS_URL = `${ROOT_URL}v1/oversea-warehouse/amazon-fba-address`;
export const OVERSEA_PRINT_BOL_WITHOUT_LOG_URL = `${ROOT_URL}v1/oversea-warehouse/printing-bol-file-non-logo/`;
export const OVERSEA_PRINT_BOL_LABEL_URL = `${ROOT_URL}v1/sale/print_bol_label/`;

export const SP_PDF_URL = `${ROOT_URL}v1/sale/performance_categories_pdf`;

// JML Tracking Numbers
export const FETCH_JML_TRACKING_NUMBER_URL = `${ROOT_URL}v2/sales/shipping_info/`;
export const PRINT_JML_LABEL_URL = `${ROOT_URL}v2/sales/shipping/new_label_for_order/`;

// carrier info
export const CARRIER_INFO_URL = `${ROOT_URL}v2/shipping/order_ltl_info/`;

// Merge PO API
export const MERGE_PURCHASE_ORDERS_API = `${ROOT_URL}v2/purchase/order/merge`
export const SALES_INVOICE_EMAIL_LAP = `${ROOT_URL}v1/purchase/send_notification/`;

// Quote
export const SET_QUOTE_URL = `${ROOT_URL}v1/sale/sales_order/sq_to_so_adjust_inv/`;
export const SET_QUOTE_ESC_URL = `${ROOT_URL}v1/sale/sales_order/sq_to_so_adjust_inv_esc/`;

// Approve
export const APPROVE_PENDING_PO_URL = `${ROOT_URL}v1/purchase/order/approve/`;

// SO to PO Davis
export const SO_TO_PO_DAVIS_URL = `${ROOT_URL}v2/so_to_po_dropship`;
export const CUSTOMER_LOG_URL = `${ROOT_URL}v1/customer/customerlogs/`;
export const GENERAL_LEDGER_URL = `${ROOT_URL}v1/ap/glaccount/`;

export const SALES_QUOTE_LAP_PRINT_URL = `${ROOT_URL}v1/sale/printquote/`

// marketing
export const MARKET_QUERY_URL = `${ROOT_URL}v1/product/marketing`
export const MARKET_SL_QUERY_URL = `${ROOT_URL}v1/product/marketing/products`

export const VENDOR_PRODUCTS_URL = `${ROOT_URL}v2/vendor-product-num`
export const VENDOR_PRICE_TABLE_URL = `${ROOT_URL}v1/mfg/subscriptionorder/vendor_product_price/`
export const MFG_ORDER_UPLOAD = `${ROOT_URL}v1/mfg/upload/`;
export const LOGICAL_LOCATION_URL = `${ROOT_URL}v1/mfg/inbound/qc/location/`;
export const RECEIVE_QC_URL = `${ROOT_URL}v1/mfg/purchaseinvoice/order/qc/`;
export const RECEIVE_DISPATCH_URL = `${ROOT_URL}v1/mfg/purchaseinvoice/order/divide_warehouse/`;
export const MFG_BOM_PRODUCTS_URL = `${ROOT_URL}v1/mfg/add_bom_product/`;
export const MFG_PURCHASE_RETURNS_URL = `${ROOT_URL}v1/mfg/purchase_return/is_defective`;
export const MFG_PURCHASE_RETURN_REVIEW_URL = `${ROOT_URL}v1/mfg/all/order/review/`;
export const MFG_SALES_ORDER_REVIEW_URL = `${ROOT_URL}v1/mfg/all/order/review/`;
export const MFG_PURCHASE_RETURN_APPROVAL_URL = `${ROOT_URL}v1/mfg/purchasereturn/order/approve/`;
export const MFG_SALES_ORDER_REQ_APPROVAL_URL = `${ROOT_URL}v1/sale/sales_order/req_approve/`;
export const MFG_SALES_ORDER_PENDING_APPROVAL_URL = `${ROOT_URL}v1/sale/sales_order/approve/`;
export const DASHBOARD_MFG_URL = `${ROOT_URL}v1/dashboard/mfg/`;
export const DASHBOARD_MR_URL = `${ROOT_URL}v1/dashboard/mr/`;
export const DASHBOARD_PR_URL = `${ROOT_URL}v1/dashboard/pr/`;
export const DASHBOARD_SCRAP_URL = `${ROOT_URL}v1/dashboard/scrap/`;
export const DASHBOARD_OUTSOURCED_URL = `${ROOT_URL}v1/dashboard/outsourcing/`;
export const DASHBOARD_SALES_ORDER_URL = `${ROOT_URL}v1/dashboard/so/`;
export const DASHBOARD_PURCHASE_ORDER_URL = `${ROOT_URL}v1/dashboard/po/`;
export const DASHBOARD_PURCHASE_RETURN_URL = `${ROOT_URL}v1/dashboard/purchaseReturn/`;
export const DASHBOARD_AP_URL = `${ROOT_URL}v1/dashboard/ap/`;
export const DASHBOARD_TRANSFER_URL = `${ROOT_URL}v1/dashboard/TransferOrder/`;
export const SYNC_TO_MES = `${ROOT_URL}v1/lmh_mes/sync_to_mes/`;



// WEBPACK FOOTER //
// ./master/jsx/actions/url.js